import { mainAPI, tripsAPI } from "../api";
import { Chat } from "../types/chat";
import {
  ClaimColleaguesListResponse,
  ColleagueForSelector,
  User,
  UsersListResponse,
} from "../types/users";
import { getUserFioShort } from "../helpers/users";

export function retrieveByTripId(trip_id: number) {
  return mainAPI.get<Chat>(`chats/${trip_id}/retrieve_by_trip_id/`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export function fetchAvailableParticipants(chatId: string) {
  return mainAPI
    .get<Array<User>>(`/chats/${chatId}/list_available_participants/`)
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export type ChatUserParams = {
  chatId: string;
  userId: string;
};

export type AssignTravelManagerParams = {
  claimPk: string;
  userId: string;
};

export function fetchChatAvailableParticipants(
  pk: string,
  limit: number,
  offset: number,
  search?: string
): Promise<Array<ColleagueForSelector>> {
  return mainAPI
    .get<UsersListResponse>(`/chats/${pk}/list_available_participants/`, {
      params: {
        limit,
        offset,
        search,
      },
    })
    .then(
      (res) => {
        return Promise.resolve(
          res.data.results.map((e) => {
            let res: ColleagueForSelector = {
              pk: e.pk,
              name: getUserFioShort(e),
              post: e.post,
              department: e.department,
              brand: e.brand,
            };
            return res;
          })
        );
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function addParticipant(data: ChatUserParams) {
  return mainAPI
    .patch(`/chats/${data.chatId}/add_participant/`, {
      participant: data.userId,
    })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function removeParticipant(data: ChatUserParams) {
  return mainAPI
    .patch(`/chats/${data.chatId}/remove_participant/`, {
      participant: data.userId,
    })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function assignTravelManager(data: AssignTravelManagerParams) {
  return tripsAPI
    .post(`/claim/${data.claimPk}/take_in_work_by_responsible/`, {
      responsible_pk: data.userId,
    })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function confirmByResponsible(claimPk: string) {
  return tripsAPI.post(`/claim/${claimPk}/confirm_by_responsible/`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export function declineByResponsible(claimPk: string) {
  return tripsAPI.post(`/claim/${claimPk}/decline_by_responsible/`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export function requestConfirmation(chatId: string) {
  return mainAPI
    .patch(`/chats/${chatId}/travel_manager_confirmation_request/`)
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function confirmCompletion(chatId: string) {
  return mainAPI.patch(`/chats/${chatId}/confirm/`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}
